/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Box } from '@material-ui/core';
import useStyles from './useStyles';

export const TabsComponent = ({
  data,
  defaultValue,
  onChange,
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(defaultValue);
  const onChangeTabs = (event, newValue) => {
    setValue(newValue);
    onChange(event, newValue);
  };
  return (
    <Box className={classes.container}>
      <Tabs
        value={value}
        onChange={onChangeTabs}
        className={classes.tabs}
        variant="fullWidth"
      >
        {
          data.map(({
            label,
            value: tabValue,
            disabled,
          }) => (
            <Tab
              className={classes.tab}
              label={label}
              value={tabValue}
              disabled={disabled}
              classes={{
                selected: classes.selected,
              }}
            />
          ))
        }
      </Tabs>
    </Box>
  );
};

TabsComponent.propTypes = {
  data: PropTypes.array,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
};

TabsComponent.defaultProps = {
  data: [],
  defaultValue: '',
  onChange: () => { },
};
